import { JsonPipe } from "@angular/common";
import { Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { ApiService } from "src/app/api.service";
import { FilesizePipe, DatetimePipe, TruncatedFilePipe as TruncatedFilePipe, ShortExceptionPipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-files-error",
	templateUrl: "./files-error.component.html",
	styleUrls: ["./files-error.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [JsonPipe, FilesizePipe, DatetimePipe, TruncatedFilePipe, ShortExceptionPipe]
})
export class FilesErrorComponent implements OnInit {
	private modalService = inject(NgbModal);
	private api = inject(ApiService);
	private route = inject(ActivatedRoute);

	@ViewChild("exceptionModal", { static: true }) public exceptionModal: any;

	public datafiles: APIResults.DataFile[];
	public selectedException: any = null;
	public selectedExceptionStack?: string = undefined;
	public selectedExceptionSubStack?: string = undefined;

	async ngOnInit(): Promise<void> {
		await this.RefreshData();
	}

	private async RefreshData() {
		this.datafiles = undefined;
		const assetId = Number(this.route.snapshot.params["assetid"]);
		const datafiles = await this.api.GetErrorFiles(assetId, 0, 200);
		this.datafiles = datafiles;
	}

	public async DownloadFile(datafile: APIResults.DataFile) {
		const filename = new TruncatedFilePipe().transform(datafile.filename);
		const assetId = Number(this.route.snapshot.params["assetid"]);
		await this.api.DownloadDataFile(assetId, datafile.datafile_id, filename);
	}

	public ShowException(exception: any) {
		try {
			this.selectedExceptionStack = undefined;
			this.selectedException = JSON.parse(exception);
			if (this.selectedException.stack) {
				this.selectedExceptionStack = this.selectedException.stack;
				delete this.selectedException.stack;
			}
			if (this.selectedException.detail && this.selectedException.detail.StackTrace) {
				this.selectedExceptionSubStack = this.selectedException.detail.StackTrace;
				delete this.selectedException.detail.StackTrace;
			}
		} catch {
			this.selectedException = exception;
		}
		this.modalService.open(this.exceptionModal, { size: "lg" });
	}
}
